// extracted by mini-css-extract-plugin
export default {"page":"page__9a81176b","header":"header__9a81176b","tab":"tab__9a81176b","content":"content__9a81176b"};